import React, { useState, useEffect } from "react";

function ThemeSwitch() {
  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem("theme") === "dark";
  });

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  return (
    <button
      onClick={toggleDarkMode}
      className="w-12 h-6 bg-gray-300 dark:bg-gray-700 rounded-full flex items-center px-1 transition-all"
    >
      <div
        className={`w-5 h-5 bg-white dark:bg-gray-300 rounded-full transform transition-all ${
          darkMode ? "translate-x-6" : "translate-x-0"
        }`}
      ></div>
    </button>
  );
}

export default ThemeSwitch;
